import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * React Router ne réinitialise pas le scroll lors d'une navigation
 * client-side : sans ça, cliquer sur un lien du footer (ou tout autre
 * lien) laisse la page à sa position de scroll précédente.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // A link to a section (/fr#home-faq-title) scrolls there itself.
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
